<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增活期宝币种"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="val" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="活动币种" prop="coinType">
          <el-select v-model="val.coinType">
            <el-option
              v-for="item in financialCoinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最小认购数量" prop="minAmount">
          <el-input-number
            v-model="val.minAmount"
            :min="0.0001"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最大认购数量" prop="maxAmount">
          <el-input-number v-model="val.maxAmount" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="精度：" prop="scale">
          <el-input-number v-model="val.scale" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="认购限额：" prop="limitAmount">
          <el-input-number v-model="val.limitAmount" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="预期年化收益：" prop="rate">
          <el-input-number v-model="val.rate" :min="0"></el-input-number>%
        </el-form-item>
        <!-- <el-form-item label="直推奖励：" prop="firstInviteRate">
          <el-input-number
            v-model="val.firstInviteRate"
            :min="0"
            :max="1"
            :step="0.01"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="间推奖励：" prop="secondInviteRate">
          <el-input-number
            v-model="val.secondInviteRate"
            :min="0"
            :max="1"
            :step="0.01"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item label="产品总量" prop="total">
          <el-input-number
            v-model="val.total"
            :min="0"
            :step="100"
          ></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="发放币种：" prop="distributionCoinType">
          <el-select v-model="val.distributionCoinType">
            <el-option
              v-for="item in financialCoinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="支出利息账号：" prop="distributionAccount">
          <el-input
            v-model="val.distributionAccount"
            placeholder="默认使用平台账号10027"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="币种利率：">
          <mutiple-input v-model="val.rateConfDto" />
        </el-form-item>
        <el-form-item label="利率规则：" prop="rateRule">
          <el-input type="textarea" v-model="val.rateRule"></el-input>
        </el-form-item>
        <el-form-item label="产品收益说明：" prop="interestText">
          <el-input type="textarea" v-model="val.interestText"></el-input>
        </el-form-item>
        <el-form-item label="标签：" prop="tagList">
          {{ tagList }}
          <el-row>
            <el-col :span="4"> </el-col>
            <el-col :span="20">
              <el-form
                v-for="(tagItem, index) in tagList"
                :key="index"
                size="mini"
                inline
                lable-width="100px"
              >
              <!-- {{ tagItem }} -->
                <el-row>
                  <el-col :span="23">
                    <el-form-item
                      v-for="item in tagItem"
                      :key="item.lang"
                      :label="item.label"
                    >
                      {{ tagItem.label }}
                      <el-input
                        v-model="tagItem.value"
                        class="width-80"
                        @change="change"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-button
                      size="mini"
                      icon="el-icon-delete"
                      type="danger"
                      circle
                      @click="remove(index)"
                      class="me-2"
                    ></el-button>
                  </el-col>
                </el-row>
              </el-form>
              <el-button
                size="mini"
                icon="el-icon-plus"
                @click="add"
              ></el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="产品图标：" prop="img">
          <upload v-model="val.img"></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MutipleInput from "../mutipleInput";
import Upload from "components/upload";
import Tags from "../tags";

export default {
  name: "cornucopiaCreate",
  data() {
    return {
      dialogVisible: false,
      val: {},
      rules: {
        coinType: {
          required: true,
          message: "请填写",
        },
        minAmount: {
          required: true,
          message: "请填写",
        },
        maxAmount: {
          required: true,
          message: "请填写",
        },
        scale: {
          required: true,
          message: "请填写",
        },
        firstInviteRate: {
          required: true,
          message: "请填写",
        },
        secondInviteRate: {
          required: true,
          message: "请填写",
        },
        distributionCoinType: {
          required: true,
          message: "请填写",
        },
      },
      tagList: [
        { lang: "zh", value: "", label: "中文" },
        { lang: "hk", value: "", label: "繁体" },
        { lang: "en", value: "", label: "英文" },
        { lang: "ko", value: "", label: "韩文" },
        { lang: "jp", value: "", label: "日文" },
        { lang: "ru", value: "", label: "俄文" },
        { lang: "tr", value: "", label: "土耳其文" },
        { lang: "vi", value: "", label: "越南文" },
        { lang: "th", value: "", label: "泰文" },
      ],
      ProductLang: [
        { lang: "zh", value: "", label: "中文" },
        { lang: "hk", value: "", label: "繁体" },
        { lang: "en", value: "", label: "英文" },
        { lang: "ko", value: "", label: "韩文" },
        { lang: "jp", value: "", label: "日文" },
        { lang: "ru", value: "", label: "俄文" },
        { lang: "tr", value: "", label: "土耳其文" },
        { lang: "vi", value: "", label: "越南文" },
        { lang: "th", value: "", label: "泰文" },
      ],
    };
  },
  components: {
    MutipleInput,
    Upload,
    Tags,
  },
  computed: {
    ...mapState("cornucopia", [
      "coinTypeList",
      "languageList",
      "financialCoinTypeList",
    ]),
    filterTagList() {
      return this.val.tagList;
    },
  },
  methods: {
    ...mapActions("cornucopia", ["create"]),
    getLanguages() {
      const result = {};
      for (const key in this.ProductLang) {
        Object.assign(result, {
          lang: key,
          label: this.ProductLang[key],
          value: "",
        });
      }
      return result;
    },
    add() {
      console.log("tgis.add", this.getLanguages());
      this.tagList.push([...this.ProductLang]);
      // this.tagList.push(this.tagList);
      console.log("this.tagList", this.tagList);
    },
    remove(index) {
      this.tagList.splice(index, 1);
    },
    change() {
      this.$emit("change:data", this.tagList);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      const rateConf =
        this.val.rateConfDto &&
        this.val.rateConfDto.reduce(
          (obj, item) => ({ ...obj, [item.key]: item.value }),
          {}
        );
        const tags=this.val.tagListv &&
        this.val.tagListv.reduce(
          (obj, item) => ({ ...obj, [item.lang]: item.value }),
          {}
        )
        console.log('tagsssssssssss',tags);
      this.create({
        ...this.val,
        rateConfDto: { rateConf },
        tagList: { rateConf },
        interestText:{ rateConf },
        rateRule:{ rateConf }
      }).then(() => {
        this.$message({
          message: "添加成功！",
          type: "success",
        });
        this.dialogVisible = false;
        this.$emit("refresh");
      });
    },
  },
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
